import styled from 'styled-components';
import MarkdownToJsx from 'markdown-to-jsx';

export const StyledMarkdown = styled(MarkdownToJsx)`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: bold;
  }
`;
